import defaultSettings from '@/settings'

const title = defaultSettings.title || 'Vant2 Project'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle}`
  }
  return `${title}`
}
